import { render, staticRenderFns } from "./OutlinedCard.vue?vue&type=template&id=83d220ec"
import script from "./OutlinedCard.vue?vue&type=script&lang=js"
export * from "./OutlinedCard.vue?vue&type=script&lang=js"
import style0 from "./OutlinedCard.vue?vue&type=style&index=0&id=83d220ec&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports